export const sha256 = async (string: string) => {
    const data = new TextEncoder().encode(string);
    const arrayBuffer = await window.crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(arrayBuffer));

    return hashArray.map(item => item.toString(16).padStart(2, '0')).join('');
};
